import type { TicketList } from './ticket-list.types'

/** Each list page's tickets by its URL, so the ticket page knows which list it was opened from.
 *  sessionStorage, so it ends with the tab; logout clears it too (auth.store.ts). */
const PREFIX = 'adx_ticket_list:'

export function readTicketList(path: string): TicketList | null {
  try {
    const raw = sessionStorage.getItem(`${PREFIX}${path}`)
    return raw ? (JSON.parse(raw) as TicketList) : null
  } catch {
    return null
  }
}

export function writeTicketList(path: string, list: TicketList): void {
  try {
    sessionStorage.setItem(`${PREFIX}${path}`, JSON.stringify(list))
  } catch {
    // A full or blocked sessionStorage only loses Previous and Next on the ticket page.
  }
}

export function clearTicketLists(): void {
  try {
    const keys: string[] = []
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i)
      if (key?.startsWith(PREFIX)) keys.push(key)
    }
    for (const key of keys) sessionStorage.removeItem(key)
  } catch {
    // Nothing kept, nothing to clear.
  }
}
